import operationTaxesType from './operationTaxesType';
import { sortBy } from 'lodash';

export default sortBy(
  [
    {
      label: 'Все виды налогов',
      value: -1,
      filterFn: () => true,
      order: 10,
    },
    {
      label: 'Налог на имущество',
      value: operationTaxesType.property,
      filterFn: getFilterFn(operationTaxesType.property),
      order: 30,
    },
    {
      label: 'Земельный налог',
      value: operationTaxesType.land,
      filterFn: getFilterFn(operationTaxesType.land),
      order: 40,
    },
    {
      label: 'Транспортный налог',
      value: operationTaxesType.transport,
      filterFn: getFilterFn(operationTaxesType.transport),
      order: 50,
    },
    {
      label: 'Налог на доходы',
      value: operationTaxesType.income,
      filterFn: getFilterFn(operationTaxesType.income),
      order: 60,
    },
    {
      label: 'Административный штраф',
      value: operationTaxesType.admPenalty,
      filterFn: getFilterFn(operationTaxesType.admPenalty),
      order: 70,
    },
    {
      label: 'Единый налоговый платеж',
      value: operationTaxesType.taxPayment,
      filterFn: getFilterFn(operationTaxesType.taxPayment),
      order: 20,
    },
  ],
  'order',
);

function getFilterFn(type) {
  return (operationObject) => operationObject.taxType.type === type;
}
